import { throttle } from '@/core';
import deepCopy from 'deepcopy';
import rdbClient from 'rdb-client';

import { getCargoCarrierTypesRequest } from '@/modules/cargoCarrierTypes/requests/getCargoCarrierTypesRequest';
import { updateCargoCarrierTypeRequest } from '@/modules/cargoCarrierTypes/requests/updateCargoCarrierTypeRequest';


export async function getCargoCarrierTypes({ state, commit }) {
	commit('set', (state) => { state.loading = true; });
	try {
		if (state.cargoCarrierTypes.length === 0) {
			await getCargoCarrierTypes();
		} else {
			await throttle(getCargoCarrierTypes, 'fetchCargoCarrierTypes', 60 * 1000);
		}
	} catch (err) {
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });

	async function getCargoCarrierTypes() {
		let response = await getCargoCarrierTypesRequest();
		commit('setCargoCarrierTypes', response);
	}
}


export async function setCargoCarrierType({ commit }, { cargoCarrierType, data, prop }) {

	if (cargoCarrierType[prop] === data) return;

	let cargoCarrierTypeClone = deepCopy(cargoCarrierType);

	commit('set', () => { cargoCarrierType[prop] = data; });

	let patch = rdbClient.createPatch(cargoCarrierTypeClone, cargoCarrierType);

	try {
		await updateCargoCarrierTypeRequest(cargoCarrierType.id, { patch });
		commit('clearErrors');

	} catch (err) {
		if (err.response) {
			commit('setErrors', { errors: err.response.data.errors, id: cargoCarrierType.id });
		}
		commit('set', () => { cargoCarrierType[prop] = cargoCarrierTypeClone[prop]; });
		throw (err);
	}
}


export default {
	getCargoCarrierTypes,
	setCargoCarrierType
};
